import Vue from 'vue'

/**
 * 多倍图指令（不做多语言）
 * 用法: v-density-img="'@/assets/imgs/game-ping/hero/hero.png'"
 * 自动匹配 hero-1x.png / hero-2x.png / hero-3x.png 并生成 srcset
 */
const imgContext = require.context(
  '../assets/imgs',
  true,
  /\.(png|jpe?g|svg)$/i,
)

const modules = {}
imgContext.keys().forEach((key) => {
  modules[normalizeAssetPath(key)] = imgContext(key)
})

function normalizeAssetPath(path) {
  return String(path || '')
    .trim()
    .replace(/\\/g, '/')
    .replace(/^@\//, '')
    .replace(/^~\//, '')
    .replace(/^(\.\/)+/, '')
    .replace(/^assets\/imgs\//, '')
    .replace(/^\/+/, '')
}

function appendScaleSuffix(path, scale) {
  if (/-(1x|2x|3x)\.[^.]+$/i.test(path)) {
    return path.replace(/-(1x|2x|3x)(\.[^.]+)$/i, `-${scale}$2`)
  }
  const lastDotIndex = path.lastIndexOf('.')
  if (lastDotIndex === -1) return path
  return `${path.slice(0, lastDotIndex)}-${scale}${path.slice(lastDotIndex)}`
}

function resolveUrl(path) {
  const normalized = normalizeAssetPath(path)
  const hit = modules[normalized]
  if (!hit) return ''
  return typeof hit === 'string' ? hit : hit.default || hit
}

function applyDensityImage(el, url) {
  if (!url || el.tagName !== 'IMG') return

  const base = normalizeAssetPath(url)
  const oneX = resolveUrl(appendScaleSuffix(base, '1x'))
  const twoX = resolveUrl(appendScaleSuffix(base, '2x'))
  const threeX = resolveUrl(appendScaleSuffix(base, '3x'))
  const fallback = resolveUrl(base)

  const src = oneX || fallback || twoX || threeX
  if (!src) {
    console.warn(`[v-density-img] Image not found: ${base}`)
    el.removeAttribute('srcset')
    return
  }

  el.src = src

  const parts = []
  if (oneX) parts.push(`${oneX} 1x`)
  if (twoX) parts.push(`${twoX} 2x`)
  if (threeX) parts.push(`${threeX} 3x`)

  if (parts.length) el.srcset = parts.join(', ')
  else el.removeAttribute('srcset')
}

Vue.directive('density-img', {
  bind(el, binding) {
    applyDensityImage(el, binding.value)
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      applyDensityImage(el, binding.value)
    }
  },
})
